import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import LoginComponent from "./LoginComponent";

const Signin = () => {
  const [showLoginFields, setShowLoginFields] = useState(false);

  return (
    <div className="signin-wrapper">
      <div className="signin-card">
        {/* Logo */}
        {!showLoginFields && (
          <div className="signin-header text-center">
            <img
              src="assets/img/logo.jpeg"
              alt="Mr. PayMaster"
              className="signin-logo"
            />
            <h2 className="signin-title">Sign In</h2>
            <p className="signin-subtitle">
              Access your payroll dashboard securely
            </p>
          </div>
        )}

        {/* Login Option */}
        {!showLoginFields && (
          <div
            className="login-option"
            onClick={() => setShowLoginFields(true)}
          >
            <FontAwesomeIcon icon={faEnvelope} />
            <span>Login via Email & Password</span>
          </div>
        )}

        {/* Login Form */}
        {showLoginFields && (
          <LoginComponent onClick={() => setShowLoginFields(false)} />
        )}
      </div>
    </div>
  );
};

export default Signin;
